import React from 'react';
import { Link } from 'react-router-dom';
import { FaGooglePlay, FaAppStoreIos } from 'react-icons/fa';
import finalImage from '../../assets/finalizar.jpg';
import Button from '../../components/Button';

import { Container, Content, AnimationContainer } from './styles';

import logoImg from '../../assets/logoCoruja.png';

const Home: React.FC = () => {
  return (
    <Container>
      <Content>
        <AnimationContainer>
          <img src={logoImg} alt="A Recreativa" />
          <br />
          <h3>Faça download em uma das nossas lojas!</h3>
          <a href="https://play.google.com/store/apps/details?id=com.recreativa.app&hl=pt_BR">
            <Button>
              <FaGooglePlay />
              <div>Play Store</div>
            </Button>
          </a>
          <a href="https://apps.apple.com/us/app/a-recreativa/id1532776453">
            <Button>
              <FaAppStoreIos />
              <div>App Store</div>
            </Button>
          </a>
        </AnimationContainer>
      </Content>
    </Container>
  );
};

export default Home;
